module.exports = __webpack_public_path__ + "static/img/background.5c9c207d.svg";